"use client";

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
import { Suspense } from "react";
import { PageTransition as Transition } from "@/ui/transition/temp";
export default function Template(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="mx-auto flex min-h-dvh max-w-8xl flex-col overflow-x-hidden! sm:px-6 lg:px-8"><div className="bg-background h-16 w-full animate-pulse" /><div className="bg-background grow" /><div className="bg-background h-32 w-full animate-pulse" /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <Suspense fallback={t1}><Transition>{children}</Transition></Suspense>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}